import { z } from "zod";
import {
  EventCategorySchema,
  EventSchema,
  Event,
  LocationSchema,
  OrgSchema,
  TicketTierSchema,
  TicketTier,
} from "../models";

// Event with detail
export const EventWithDetailSchema = EventSchema.extend({
  host: OrgSchema,
  location: LocationSchema.optional().nullable(),
  ticketTiers: z.array(TicketTierSchema),
  category: EventCategorySchema.optional().nullable(),
  booked: z.boolean().optional(),
});
export type EventWithDetail = z.infer<typeof EventWithDetailSchema>;

// Create event schema
export const CreateEventSchema = EventSchema.omit({
  id: true,
  taken: true,
  status: true,
  createdAt: true,
  updatedAt: true,
}).extend({
  ticketTiers: z.array(
    TicketTierSchema.omit({
      id: true,
      eventId: true,
      taken: true,
      status: true,
      createdAt: true,
      updatedAt: true,
    })
  ),
});
export type CreateEvent = z.infer<typeof CreateEventSchema>;

// Update event schema
export const UpdateEventSchema = EventSchema.partial().omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});
export type UpdateEvent = z.infer<typeof UpdateEventSchema>;

// Query events request schema
export const QueryEventsRequestSchema = z.object({
  limit: z
    .string()
    .default("6")
    .transform((val) => {
      if (val === undefined) return 6;
      const num = parseInt(val, 10);
      if (isNaN(num) || num < 1 || num > 50) return 6;
      return num;
    }),
  page: z
    .string()
    .default("1")
    .transform((val) => {
      if (val === undefined) return 1;
      const num = parseInt(val, 10);
      if (isNaN(num) || num < 1) return 1;
      return num;
    }),
  categoryId: z.array(z.string()).optional(),
  hostId: z.string().optional(),
});
export type QueryEventsRequest = z.infer<typeof QueryEventsRequestSchema>;

// ------------------------------------------------------------------------------------------------
export function remainTicketAmount(
  event: Event,
  ticketTier: TicketTier
): number {
  return Math.min(event.cap - event.taken, ticketTier.cap - ticketTier.taken);
}
